<!-- eslint-disable max-len -->
<!-- eslint-disable vuejs-accessibility/label-has-for -->
<!-- eslint-disable vuejs-accessibility/form-control-has-label -->
<template>
  <div class="password-view container">
    <div class="breadcrumb-password-view py-3 row">
      <Breadcrumb
        :path-list="{
          'Consulta validação de domínio':
            'domain-validation/check-domain-validation',
        }"
      />
    </div>
    <div class="title-ssl-certificate-view text-start">
      <h2 class="fw-500">Consulta validação de domínio</h2>
    </div>
    <div class="content-password-view mt-4">
      <div class="d-flex flex-row row">
        <div class="col-12 col-md-6 d-none d-lg-block text-center">
          <img
            style="max-width: 450px"
            alt="emitir-certificado"
            src="@/assets/images/instalar-certificado-ssl.svg"
          />
        </div>
        <div class="col-12 col-lg-6">
          <div class="description-password-view d-flex text-start">
            <p class="fs-6">
              Para consultar o status da solicitação de validação de domínio via
              {{ validationText }}, vamos precisar do nome do usuário e a senha
              de emissão
            </p>
          </div>
          <div class="input-create-user">
            <div class="input-label mb-1">
              <label for="user">Usuário *</label>
            </div>
            <Input
              v-model="model.user"
              icon="user"
              type="text"
              :is-required="true"
              :is-disabled="form.disabledUserName"
              placeholder="Ex: 01ED184010150778 11116521754247"
              class="mb-4"
            />
          </div>
          <div class="input-create-password col-12">
            <div class="input-label mb-1">
              <label for="user">Senha de emissão *</label>
              <Icon
                id="password-info-tooltip"
                class="icon ms-2 align-text-bottom"
                name="circle-question"
                :style="'line-height: 1.65rem'"
              ></Icon>
            </div>
            <Input
              v-model="model.password"
              icon="lock"
              type="password"
              :is-required="true"
              placeholder="Digite sua senha aqui"
              :error-log="error"
              class="mb-5"
            />
          </div>
          <div class="d-flex justify-content-end mt-2">
            <button
              id="next-step-button"
              class="btn"
              type="button"
              :class="[!isValid ? 'btn-secondary' : 'btn-primary']"
              :disabled="!isValid"
              @click="handleLogin"
            >
              <span>Avançar</span>
              <Icon class="ms-2" name="arrow-right"></Icon>
            </button>
          </div>
        </div>
      </div>
    </div>
    <Contact />
    <ModalNotPropagated ref="modalNotPropagated" />
  </div>
</template>

<script lang="ts">
  import { defineComponent } from 'vue'
  import Contact from '@/components/Molecules/Contact.vue'
  import Icon from '@/components/Atoms/Icon.vue'
  import Input from '@/components/Atoms/Input.vue'
  import Breadcrumb from '@/components/Molecules/Breadcrumbs.vue'
  import { Tooltip } from 'bootstrap'
  import {
    StateSolicitation,
    useSolicitation,
  } from '@/store/Pinia/useSolicitation.store'
  import { mapActions, mapState } from 'pinia'
  import { useAR } from '@/store/Pinia/useAR.store'
  import ModalNotPropagated from './dns/ModalNotPropagated.vue'
  import { useToastGlobal } from '@/store/Pinia/useToastGlobal.store'
  import { useModalLoading } from '@/store/Pinia/useModalLoading.store'
  import { useDynamicForms } from '@/store/Pinia/useDynamicForms.store'
  import { ESolicitationStatus } from '@/helpers/ESisar.enum'
  import emissionController from '@/infra/BirdId/controllers/emission.controller'
  import { domainValidationController } from '@/infra/DomainValidation/domainValidation.controller'
  import dnsValidationController from '@/infra/DomainValidation/dns.controller'
  import httpValidationController from '@/infra/DomainValidation/http.controller'
  import {
    domainDnsValidationDataType,
    domainHttpValidationDataType,
    useDomainValidation,
  } from '@/store/Pinia/useDomainValidation.store'
  import { useOeRecaptcha } from '@/utils/useOeRecaptcha'

  export default defineComponent({
    components: {
      Contact,
      Breadcrumb,
      Icon,
      Input,
      ModalNotPropagated,
    },
    setup() {
      return {
        oeRecaptcha: useOeRecaptcha(),
      }
    },
    data: () => ({
      model: {
        user: '',
        password: '',
      },
      form: {
        typeValidation: 'http',
        disabledUserName: true,
      },
      tooltipPass: null as Tooltip | null,
      error: '',
    }),
    computed: {
      ...mapState(useSolicitation, ['getSolicitation']),
      ...mapState(useAR, ['getSubdomain']),
      ...mapState(useDomainValidation, ['getType']),
      cdSolicitacao() {
        return this.model.user.replace(' ', ':').split(':')[0]
      },
      isValid() {
        return this.model.user && this.model.password
      },
      controllerByType() {
        return this.form.typeValidation === 'dns'
          ? dnsValidationController
          : httpValidationController
      },
      validationText() {
        return this.form.typeValidation === 'dns'
          ? 'Registro CNAME no DNS'
          : 'Requisição HTTP'
      },
    },
    methods: {
      ...mapActions(useToastGlobal, ['toggleToastGlobal']),
      ...mapActions(useModalLoading, ['setIsLoading']),
      ...mapActions(useSolicitation, [
        'setCodigoSolicitacao',
        'setUserName',
        'saveDataSolicitation',
      ]),
      ...mapActions(useDynamicForms, ['setPassword']),
      ...mapActions(useDomainValidation, [
        'setDomainHttpValidationData',
        'setDomainDnsValidationData',
      ]),
      async handleLogin() {
        try {
          this.setIsLoading({
            isLoading: true,
            title: 'Aguarde enquanto estamos buscando sua solicitação.',
            message: '',
            image: 'clock',
          })

          let recaptchaTokenGetSolicitationData =
            await this.oeRecaptcha.getToken('getsolicitationdata')

          const { situacao, isQsa } =
            await emissionController.getSolicitationData({
              solicitacao: this.cdSolicitacao,
              arsubdomain: this.getSubdomain,
              recaptcha_token: recaptchaTokenGetSolicitationData,
            })

          if (situacao.id === ESolicitationStatus.EMITIDA.toString()) {
            this.error = 'Sua solicitação já se encontra com status de emitida!'
            return
          }

          recaptchaTokenGetSolicitationData = await this.oeRecaptcha.getToken(
            'getsolicitationdata',
          )

          const { domainsValidation } =
            await domainValidationController.getDomainsValidation({
              codigo: this.cdSolicitacao,
              senha: this.model.password,
              recaptcha_token: recaptchaTokenGetSolicitationData,
            })

          const response = await this.controllerByType.choseMethod({
            codigo: this.cdSolicitacao,
            senha: this.model.password,
            domain: domainsValidation[0].domain,
          })

          this.saveDataSolicitation({
            ...this.getSolicitation,
            isQsa,
          } as StateSolicitation)

          if (this.form.typeValidation === 'dns') {
            this.setData()
            const data = response
              .choosedValidationData[0] as domainDnsValidationDataType
            this.setDomainDnsValidationData(data)
            this.$router.push({ path: 'dns-instructions' })
          }

          if (this.form.typeValidation === 'http') {
            this.setData()
            const data = response
              .choosedValidationData[0] as domainHttpValidationDataType
            this.setDomainHttpValidationData(data)
            this.$router.push({ path: 'http-instructions' })
          }
        } catch (error) {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          const err = error as any

          if (err.response && err.response.data.message) {
            if (
              err.response.data.message ===
              'matheuscfrancisco.dev.br already verified'
            ) {
              this.error = 'Seu domínio já está validado.'
            }

            if (
              // eslint-disable-next-line operator-linebreak
              err.response?.data.message ===
                'Código e/ou senha incorreto(s).' ||
              err.response?.data.message === 'Solicitação não encontrada.'
            ) {
              this.error = err.response?.data.message
              return
            }
          }
        } finally {
          this.setIsLoading({ isLoading: false })
        }
      },
      setData() {
        this.setCodigoSolicitacao(this.cdSolicitacao)
        this.setUserName(this.model.user)
        this.setPassword(this.model.password)
      },
    },
    mounted() {
      this.tooltipPass = new Tooltip('#password-info-tooltip', {
        title:
          'A senha de emissão é a senha que você digitou enquanto preenchia seu cadastro no momento da emissão do seu Certificado. ',
        placement: 'top',
      })

      if (this.getSolicitation.userName === '') {
        this.form.disabledUserName = false
      }

      this.model.user = this.getSolicitation.userName
      this.form.typeValidation = this.getType
    },
  })
</script>

<style lang="stylus" scoped>
  .title-ssl-certificate-view
    font-size: 24px
    padding-bottom: 1.5rem

  .input-label
    width: 100%;
    text-align: left;

  @media screen and (max-width: 992px)
    #next-step-button
      width: 100%
</style>
